/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function AppleWhite(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'AppleWhite',
      'aria-hidden': true,
      focusable: false,
      width:  35 * scale,
      height: 25 * scale,
      viewBox: '0 0 35 25',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('g', {"fill":"none","fillRule":"evenodd"},createElement('rect', {"width":"35","height":"25","fill":"#FFF","rx":"3.316"}),createElement('text', {"fill":"#1A1A1A","fontFamily":"Monaco","fontSize":"26"},createElement('tspan', {"x":"9.699","y":"20"},""))))
}
